import CopyToBufferButton from "@entrilia/shared/components/inputs/CopyToBufferButton";
import SparklesIcon from "@entrilia/shared/icons/SparklesIcon";
import type { SxProps, Theme } from "@mui/material";
import { Box, Paper, Stack, Typography } from "@mui/material";
import type { ComponentProps } from "react";
import ChatMessageContent from "./ChatMessageContent";
import ChatSteps from "./ChatSteps";

interface Props extends ComponentProps<typeof ChatMessageContent> {
  showHeader: boolean;
}

const COPY_BUTTON_CLASS = "chat-message-copy";

const assistantMessageSx: SxProps<Theme> = {
  [`& .${COPY_BUTTON_CLASS}`]: { visibility: "hidden" },
  [`&:hover .${COPY_BUTTON_CLASS}`]: { visibility: "visible" },
};

const ChatMessage = ({ showHeader, ...contentProps }: Props) => {
  const { item } = contentProps;

  if (item.source === "user") {
    return (
      <Paper variant="outlined" sx={{ alignSelf: "end", maxWidth: "80%", px: 2, py: 1.5 }}>
        <ChatMessageContent {...contentProps} />
      </Paper>
    );
  }

  return (
    <Stack spacing={1} sx={assistantMessageSx}>
      {showHeader && (
        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
          <SparklesIcon color="primary" />
          <Typography variant="subtitle2">Assistant</Typography>
        </Stack>
      )}
      {item.steps && <ChatSteps steps={item.steps} lastStepState={item.lastStepState} />}
      {!item.isPending && item.usedTools && item.usedTools.length > 0 && (
        <Typography variant="caption" color="textSecondary">
          Used tools: {item.usedTools.join(", ")}
        </Typography>
      )}
      <ChatMessageContent {...contentProps} />
      {!item.isPending && item.messageText && (
        <Box className={COPY_BUTTON_CLASS}>
          <CopyToBufferButton textToCopy={item.messageText} />
        </Box>
      )}
    </Stack>
  );
};

export default ChatMessage;
